import { useContext, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import SubgraphContext from 'contexts/SubgraphContext';
import { Hook, WalletConnectionContext } from 'common-client';
import { Token } from '@uniswap/sdk-core';
import { AuctionTokensQueryResponse, GET_AUCTION_TOKEN_IDS } from '../queries/auction';

/**
 * Hook for fetching auction tokens
 */
export function useAuctionTokens(
  pollInterval?: number,
): Hook<Token[]> {
  const { auction } = useContext(SubgraphContext);
  const { chain } = useContext(WalletConnectionContext);

  const { loading, error, data } = useQuery<AuctionTokensQueryResponse>(
    GET_AUCTION_TOKEN_IDS,
    {
      client: auction!!,
      pollInterval,
    },
  );

  return useMemo(() => {
    if (loading) return Hook.loading();
    if (error || !data) return Hook.error('Failed to fetch auctionTokenIds');
    const auctionTokenIds = data.tokens.map(({
      id, decimals, symbol, name,
    }) => new Token(
      chain,
      id,
      parseInt(decimals, 10),
      symbol,
      name,
    ));
    return Hook.success(auctionTokenIds);
  }, [data, error, loading]);
}
